<template>
    <AppLayout :contrast="true" title="Crear usuario">
        <Toast />
        <Breadcrumb name="Usuarios" routeName="usuarios" page="Crear usuario" />

        <form class="p-2">
            <div class="flex flex-col lg:flex-row lg:w-full">
                <div
                    class="bg-white rounded-lg shadow p-5 m-2 lg:mx-4 lg:w-1/2"
                >
                    <div class="font-medium text-gray-600 text-lg mb-2">
                        Datos básicos
                    </div>
                    <div class="flex flex-col h-24">
                        <label for="username" class="my-1 text-gray-700">
                            Username<span class="text-red-400">*</span>
                        </label>
                        <input
                            type="text"
                            id="username"
                            :class="[
                                't-input',
                                errors?.username && 't-input-invalid',
                            ]"
                            v-model="form.username"
                            autofocus
                            required
                            placeholder="ej. santiago463"
                        />
                        <small
                            v-if="errors?.username"
                            id="username-help"
                            class="p-error"
                        >
                            {{ errors?.username[0] }}
                        </small>
                    </div>

                    <div class="flex flex-col h-24">
                        <label for="password" class="my-1 text-gray-700">
                            Contraseña<span class="text-red-400">*</span>
                        </label>
                        <PasswordInput
                            id="password"
                            v-model:value="form.password"
                            placeholder="Al menos 8 digitos"
                            :hasErrors="errors?.password ? true : false"
                        />
                        <small
                            v-if="errors?.password"
                            id="password-help"
                            class="p-error"
                        >
                            {{ errors?.password[0] }}
                        </small>
                    </div>

                    <div class="flex flex-col h-24">
                        <label
                            for="password_confirmation"
                            class="my-1 text-gray-700"
                        >
                            Confirmar contraseña<span class="text-red-400"
                                >*</span
                            >
                        </label>
                        <PasswordInput
                            id="password_confirmation"
                            v-model:value="form.password_confirmation"
                            placeholder="confirmar contraseña"
                            :hasErrors="
                                errors?.password_confirmation ? true : false
                            "
                        />
                        <small
                            v-if="errors?.password_confirmation"
                            id="password_confirmation-help"
                            class="p-error"
                        >
                            {{ errors?.password_confirmation[0] }}
                        </small>
                    </div>

                    <div class="flex flex-col h-24">
                        <label for="name" class="my-1 text-gray-700">
                            Nombre<span class="text-red-400">*</span>
                        </label>
                        <input
                            type="text"
                            id="name"
                            :class="[
                                't-input',
                                errors?.name && 't-input-invalid',
                            ]"
                            v-model="form.name"
                            required
                            placeholder="ej. Santiago García"
                        />
                        <small
                            v-if="errors?.name"
                            id="name-help"
                            class="p-error"
                        >
                            {{ errors?.name[0] }}
                        </small>
                    </div>

                    <div class="flex flex-col h-24">
                        <label for="email" class="my-1 text-gray-700">
                            Email<span class="text-red-400">*</span>
                        </label>
                        <input
                            type="email"
                            id="email"
                            :class="[
                                't-input',
                                errors?.email && 't-input-invalid',
                            ]"
                            v-model="form.email"
                            required
                            placeholder="ej. santiago.garcia@gmail.com"
                        />
                        <small
                            v-if="errors?.email"
                            id="email-help"
                            class="p-error"
                        >
                            {{ errors?.email[0] }}
                        </small>
                    </div>

                    <div class="flex flex-col h-24">
                        <label for="telefono" class="my-1 text-gray-700">
                            Telefono
                        </label>
                        <input
                            type="tel"
                            id="telefono"
                            :class="[
                                't-input',
                                errors?.telefono && 't-input-invalid',
                            ]"
                            v-model="form.telefono"
                            required
                            placeholder="ej. +54 11 1234-5678"
                        />
                        <small
                            v-if="errors?.telefono"
                            id="telefono-help"
                            class="p-error"
                        >
                            {{ errors?.telefono[0] }}
                        </small>
                    </div>
                    <div class="flex flex-col h-24">
                        <div class="text-[12px] text-gray-600">
                            (<span class="text-red-400">*</span>) es requerido
                        </div>
                    </div>
                </div>
                <div
                    class="bg-white rounded-lg shadow h-full p-5 m-2 lg:mx-4 lg:w-1/2"
                >
                    <div class="font-medium text-gray-600 text-lg mb-2">
                        Información de perfil
                    </div>
                    <div class="flex flex-col h-24">
                        <label for="tipo" class="my-1 text-gray-700"
                            >Tipo de usuario<span class="text-red-400"
                                >*</span
                            ></label
                        >
                        <Dropdown
                            v-model="tipo_usuario"
                            placeholder="Seleccionar tipo"
                            :options="tipos_usuarios"
                            optionValue="tipo"
                            optionLabel="label"
                            id="tipo"
                            class="h-[42px] flex items-center"
                        />
                        <small
                            v-if="errors?.tipo"
                            id="tipo-help"
                            class="p-error"
                        >
                            {{ errors?.tipo[0] }}
                        </small>
                    </div>

                    <template v-if="necesita_cliente_global">
                        <div class="flex flex-col h-24">
                            <label
                                for="cliente_global"
                                class="my-1 text-gray-700"
                                >Cliente global</label
                            >
                            <Dropdown
                                v-model="cliente_global_id"
                                placeholder="Seleccionar cliente global"
                                :options="clientes_globales"
                                optionValue="id"
                                optionLabel="nombre"
                                id="cliente_global"
                                class="h-[42px] flex items-center"
                            />
                        </div>
                    </template>

                    <template v-if="necesita_cliente">
                        <div class="flex flex-col h-24">
                            <label for="cliente" class="my-1 text-gray-700"
                                >Cliente</label
                            >
                            <Dropdown
                                v-model="cliente_id"
                                placeholder="Seleccionar cliente"
                                :options="clientes"
                                optionValue="id"
                                optionLabel="nombre"
                                id="cliente_global"
                                class="h-[42px] flex items-center"
                            />
                        </div>
                    </template>

                    <template v-if="necesita_sucursal">
                        <div class="flex flex-col h-24">
                            <label for="sucursal" class="my-1 text-gray-700"
                                >Sucursal</label
                            >
                            <Dropdown
                                v-model="sucursal_id"
                                placeholder="Seleccionar sucursal"
                                :options="sucursales"
                                optionValue="id"
                                optionLabel="nombre"
                                id="sucursal"
                                class="h-[42px] flex items-center"
                            />
                        </div>
                    </template>
                </div>
            </div>
            <div class="m-4 flex justify-end">
                <Button @click.prevent="store"> Crear usuario </Button>
            </div>
        </form>
    </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout.vue";
import { Link } from "@inertiajs/inertia-vue3";
import { Icon } from "@vicons/utils";
import { AngleRight } from "@vicons/fa";
import Breadcrumb from "@/shared/Breadcrumb.vue";
import Button from "@/shared/Button.vue";
import PasswordInput from "./components/PasswordInput.vue";
import axios from "axios";

export default {
    components: {
        AppLayout,
        Link,
        PasswordInput,
        Icon,
        AngleRight,
        Breadcrumb,
        Button,
    },
    props: {
        tipos_usuarios: Array,
    },
    data() {
        return {
            tipo_usuario: null,
            cliente_global_id: null,
            cliente_id: null,
            sucursal_id: null,

            clientes_globales: [],
            clientes: [],
            sucursales: [],

            necesita_cliente_global: false,
            necesita_cliente: false,
            necesita_sucursal: false,

            errors: null,
            form: {
                name: "",
                email: "",
                password: "",
                password_confirmation: "",
                username: "",
                telefono: "",
                tipo: this.tipo_usuario,
                cliente_global_id: this.cliente_global_id,
                cliente_id: this.cliente_id,
                sucursal_id: this.sucursal_id,
            },
        };
    },
    watch: {
        tipo_usuario(newState) {
            this.resetRequisitos();
            this.form.tipo = newState;
            if (newState === "super_admin") {
                return;
            } else if (newState === "global_admin") {
                this.necesita_cliente_global = true;
                this.getClientesGlobales();
            } else if (newState === "cliente_admin") {
                this.necesita_cliente_global = true;
                this.necesita_cliente = true;
                this.getClientesGlobales();
            } else if (newState === "sucursal_admin") {
                this.necesita_cliente_global = true;
                this.necesita_cliente = true;
                this.necesita_sucursal = true;
                this.getClientesGlobales();
            }
        },
        cliente_global_id(newState) {
            if (
                this.tipo_usuario === "cliente_admin" ||
                this.tipo_usuario === "sucursal_admin"
            ) {
                if (newState !== null) {
                    this.form.cliente_global_id = this.cliente_global_id;
                    this.getClientes();
                }
            } else if (this.tipo_usuario === "global_admin") {
                this.form.cliente_global_id = this.cliente_global_id;
            }
        },
        cliente_id(newState) {
            if (this.tipo_usuario === "sucursal_admin" && newState !== null) {
                this.form.cliente_id = this.cliente_id;
                this.getSucursales();
            } else if (
                this.tipo_usuario === "cliente_admin" &&
                newState !== null
            ) {
                this.form.cliente_id = this.cliente_id;
            }
        },
        sucursal_id(newState) {
            if (newState !== null) {
                this.form.sucursal_id = this.sucursal_id;
            }
        },
    },
    methods: {
        resetRequisitos() {
            this.necesita_cliente_global = false;
            this.necesita_cliente = false;
            this.necesita_sucursal = false;
            this.cliente_global_id = null;
            this.cliente_id = null;
            this.sucursal_id = null;
        },
        triggerToast() {
            this.$toast.add({
                severity: "error",
                summary: "Faltan datos",
                detail: "Selecciona los datos restantes",
                life: 3000,
            });
        },
        getClientesGlobales() {
            let url = "/usuarios/get-clientes-globales";
            axios
                .get(url)
                .then((res) => {
                    if (res.status === 200) {
                        this.clientes_globales = res.data;
                    }
                })
                .catch((err) => console.log(err));
        },
        getClientes() {
            axios
                .get("/usuarios/get-clientes/" + this.cliente_global_id)
                .then((res) => {
                    if (res.status === 200) {
                        this.clientes = res.data;
                    }
                })
                .catch((err) => console.log(err));
        },
        getSucursales() {
            axios
                .get("/usuarios/get-sucursales/" + this.cliente_id)
                .then((res) => {
                    if (res.status === 200) {
                        this.sucursales = res.data;
                    }
                })
                .catch((err) => console.log(err));
        },
        store() {
            if (
                this.necesita_cliente_global &&
                this.cliente_global_id === null
            ) {
                this.triggerToast();
                return;
            }
            if (this.necesita_cliente && this.cliente_id === null) {
                this.triggerToast();
                return;
            }
            if (this.necesita_sucursal && this.sucursal_id === null) {
                this.triggerToast();
                return;
            }

            axios
                .post("/usuarios", this.form)
                .then((res) => {
                    if (res.status === 200) {
                        this.$inertia.visit("/usuarios");
                    }
                })
                .catch((err) => {
                    console.log(err);
                    if (err.response.status === 422) {
                        this.errors = err.response.data.errors;
                    }
                });
        },
    },
};
</script>
